<template>
  <div class="page">


    <div class="content">
      <div style="height:20px;"></div>
      <div class="content_top">
        <div :class="i == index ? 'content_topchilds' : 'content_topchild'" v-for="(item,index) in list" :key="index" @click="select(index)">{{item}}</div>
      </div>
      <div class="content_bottom">
        <div v-show="i==0" style="height:100%;">
          <div class="content_bottom_one">
            <div>
              <span>总资产</span>
              <div>
                <span style="font-size:2rem;">{{data.z_money}}</span>
                <span>￥</span>
              </div>
            </div>
            <div>
              <span>可提现</span>
              <div>
                <span style="font-size:2rem;">{{data.total_money}}</span>
                <span>￥</span>
              </div>
            </div>
            <div>
              <span>已冻结</span>
              <div>
                <span style="font-size:2rem;">{{data.freeze_money}}</span>
                <span>￥</span>
              </div>
            </div>
          </div>

          <div class="content_bottom_child">
            <div class="content_bottom_a">
              <div style="width:70%">
                <span>已提现</span>
                <div>
                  <span style="font-size:2rem;">{{data.tx_money}}</span>
                  <span>￥</span>
                </div>
              </div>
            </div>
            <div class="content_bottom_b">
              <div style="width:70%">
                <span>总收入</span>
                <div>
                  <span style="font-size:2rem;">{{data.sr_money}}</span>
                  <span>￥</span>
                </div>
              </div>
            </div>
            <div class="content_bottom_c">
              <div style="width:70%">
                <span>总支出</span>
                <div>
                  <span style="font-size:2rem;">{{data.zc_money}}</span>
                  <span>￥</span>
                </div>
              </div>
            </div>
          </div>

          <div class="tool">
            <div class="tool_child" @click="detail('firstone')">充值</div>
            <div class="tool_child" @click="detail('withdrawal')">提现</div>
            <div class="tool_child" @click="detail('thirdone')">对外收款</div>
            <div class="tool_child" @click="detail('secondone')">对外付款</div>
            <div class="tool_child" @click="detail('fourthone')">发红包</div>
          </div>
          <div style="height:150px;"></div>
        </div>

        <div v-show="i==1" style="height:100%;">
          <el-tabs v-model="activeNames" @tab-click="handleClick">
            <el-tab-pane label="在线充值" name="firstone">
              <div>
                <div style="padding-top:38px;padding-left:21px;margin-bottom:20px;">
                  <span style="padding-right:10px;">账户余额</span>
                  <span style="color:#4C71DB;">￥</span>
                  <span style="font-size:.25rem;color:#4C71DB;">{{data.total_money}}</span>
                  <span>元</span>
                </div>
                <el-form :model="forms" :label-position="labelPosition" label-width="80px" :rules="rule" ref="ruleForms">
                  <el-form-item label="充值金额" prop="money">
                    <el-input style="width:300px;" v-model="forms.money" placeholder="  请输入充值金额"></el-input>
                    <span style="padding-left:10px;color:#c0c4cc;">元</span>
                  </el-form-item>
                </el-form>

                <div style="margin-top:20px;padding-left:21px;display:flex;">
                  <span style="padding-right:10px;">支付方式</span>

                  <div class="contentbottonchild" @mouseenter="over" @mouseleave="leave" v-show="active==false">
                    <img src="/img/payb.png" />
                    <span>微信支付</span>
                  </div>
                  <div class="contentbottonchilda" v-show="active == true" @mouseenter="over" @mouseleave="leave" @click="submitwechat('ruleForms')">
                    <img src="/img/paya.png" />
                    <span>微信支付</span>
                  </div>
                  <div class="contentbottonchild" style="margin-left:35px;" @mouseenter="flags = true" @mouseleave="flags = false" v-show="flags == false">
                    <img src="/img/payd.png" />
                    <span>支付宝支付</span>
                  </div>
                  <div class="contentbottonchildb" style="margin-left:35px;" @mouseenter="flags = true" @mouseleave="flags = false" v-show="flags == true" @click="submitalipay('ruleForms')">
                    <img src="/img/payc.png" />
                    <span>支付宝支付</span>
                  </div>

                  <el-dialog title="微信支付" :visible.sync="payflag" width="30%" center>
                    <div>
                      <div style="text-align:center;">
                        <span>支付金额:</span>
                        <span style="color:red;">￥{{this.forms.money}}</span>
                        <span>元</span>
                      </div>

                      <div class="paymentsty" v-loading="loading" element-loading-text="已扫码支付中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <canvas ref="canvas"></canvas>
                      </div>
                      <div style="text-align:center;">
                        <span>请使用微信扫码支付</span>
                      </div>
                    </div>
                  </el-dialog>
                </div>
                <div style="height:150px;"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="对外付款" name="secondone">
              <div class="asidebox" style="overflow-y:scroll;overflow-x:hidden;height:450px;">
                <div class="asidebox_child">
                  <div style="color:#999999;">付款方式</div>
                  <div v-for="(item,index) in types" :key="index" class="asideboxs">
                    <span :class="typei == index?'btns':'btn'" @click="selecttype(index)">{{item}}</span>
                  </div>
                </div>

                <div class="asidebox_child" style="margin:10px 0;">
                  <div style="color:#999999;">选择项目</div>
                  <div class="asideboxs">
                    <el-select v-model="value" placeholder="请选择" @change="selectproject">
                      <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="asidebox_child">
                  <div style="color:#999999;">账户余额</div>
                  <div class="asideboxs" style="align-items: center;">
                    <span style="color:#4C71DB;">￥</span>
                    <span style="font-size:.25rem;color:#4C71DB;">{{data.total_money}}</span>
                    <span>元</span>
                  </div>
                </div>

                <div class="asidebox_child" v-show="this.typei == 1">
                  <div style="color:#999999;padding-right:10px;">上传文件</div>
                  <el-upload ref="upload" :accept="fileType.join(',')" :limit="1" :headers="upload.headers" :action="upload.url" :disabled="upload.isUploading" :before-upload="beforeUpload" :on-progress="handleFileProgress" :on-success="handleFileSuccess" :auto-upload="false" :show-file-list="fileflag" :data="{project_id:projectid}" drag>
                    <i class="el-icon-upload" />
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <div slot="tip" class="el-upload__tip" style="color: red;">
                      <div>
                        提示：仅允许导入“xls”或“xlsx”格式文件！
                      </div>
                      <div>
                        注：必须按照文件格式内容填写
                      </div>
                    </div>
                  </el-upload>
                  <div class="asideboxs" style="align-items:center;">
                    <div class="btns" @click="submitUpload">上传文件</div>
                    <div style="padding-left:20px;color:#4a72d9;" @click="formatdownload">文件格式下载</div>
                  </div>
                </div>

                <div class="asidebox_child" style="margin:10px 0;">
                  <div style="color:#999999;">付款明细</div>
                  <div class="asideboxs">
                    付款总金额
                    <span style="color:#557bdf;">
                      ￥
                      <span style="font-size:.16rem;">{{totalmoney}}</span>
                    </span>元
                  </div>
                </div>

                <div class="asidebox_child">
                  <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
                  <div class="asideboxss">
                    <div class="btns" v-show="typei == 0" style="width:100px;height:2rem;" @click="payee">选择收款人</div>
                    <el-table max-height="150" :data="tableData" :border="false" style="width: 100%">
                      <el-table-column prop="nickname" label="收款人" width="180"></el-table-column>
                      <el-table-column label="金额" width="180">
                        <template slot-scope="scope">
                          <input type="number" @blur="blur" v-model="tableData[scope.$index].money" />
                        </template>
                      </el-table-column>
                      <el-table-column label="备注" width="250">
                        <template slot-scope="scope">
                          <input type="text" v-model="tableData[scope.$index].content" />
                        </template>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <span @click="del(scope.$index)" style="color:red;">删除</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>

                  <el-dialog title="选择收款人" :visible.sync="paydialog" width="30%" center>
                    <div>
                      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                      <div style="margin: 25px 0;"></div>
                      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="(city,index) in cities" :label="city" :key="index">{{city.nickname}}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="confirm">确 定</el-button>
                      <el-button @click="paydialog = false">取 消</el-button>
                    </span>
                  </el-dialog>
                </div>

                <div class="asidebox_child" style="margin:10px 0;" v-show="this.typei == 1">
                  <div style="color:#999999;">付款说明</div>
                  <div class="asideboxs">
                    <textarea cols="30" rows="2" v-model="instructionss"></textarea>
                  </div>
                </div>

                <div class="asidebox_child">
                  <div style="color:#999999;">输入密码</div>
                  <div class="asideboxs">
                    <input type="password" v-model="payypwd" />
                  </div>
                </div>

                <div class="asidebox_child" style="margin-top:10px;padding-bottom:10px;">
                  <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
                  <div class="asideboxss">
                    <div class="btns" @click="queren">确认付款</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="对外收款" name="thirdone">
              <div class="asidebox" style="overflow-y:scroll;overflow-x:hidden;height:450px;">
                <div class="asidebox_child">
                  <div style="color:#999999;">收款方式</div>
                  <div v-for="(item,index) in types" :key="index" class="asideboxs">
                    <span :class="typeis == index?'btns':'btn'" @click="selecttypes(index)">{{item}}</span>
                  </div>
                </div>

                <div class="asidebox_child" style="margin:10px 0;">
                  <div style="color:#999999;">选择项目</div>
                  <div class="asideboxs">
                    <el-select v-model="valueoption" placeholder="请选择" @change="selectprojects">
                      <el-option v-for="(item,index) in option" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="asidebox_child" v-show="this.typeis == 1">
                  <div style="color:#999999;padding-right:10px;">上传文件</div>
                  <el-upload ref="uploads" :accept="fileTypes.join(',')" :limit="1" :headers="uploads.headers" :action="uploads.url" :disabled="uploads.isUploading" :before-upload="beforeUploads" :on-progress="handleFileProgresss" :on-success="handleFileSuccesss" :auto-upload="false" :data="uploads.files" drag>
                    <i class="el-icon-upload" />
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <div slot="tip" class="el-upload__tip" style="color: red">提示：仅允许导入“xls”或“xlsx,doc,docx”格式文件！</div>
                  </el-upload>
                  <div class="asideboxs" style="align-items:center;">
                    <div class="btns" @click="submitUploads">上传文件</div>
                    <!-- <div style="padding-left:20px;color:#4a72d9;">导出人员</div> -->
                  </div>
                </div>

                <div class="asidebox_child" style="margin:10px 0;">
                  <div style="color:#999999;">付款明细</div>
                  <div class="asideboxs">
                    付款总金额
                    <span style="color:#557bdf;">
                      ￥
                      <span style="font-size:.16rem;">{{totalmoneys}}</span>
                    </span>元
                  </div>
                </div>

                <div class="asidebox_child">
                  <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
                  <div class="asideboxss">
                    <div class="btns" style="width:100px;height:30px;" @click="payees">选择付款人</div>
                    <el-table max-height="150" :data="tableDatas" :border="false" style="width: 100%">
                      <el-table-column prop="nickname" label="收款人" width="180"></el-table-column>
                      <el-table-column label="金额" width="180">
                        <template slot-scope="scope">
                          <input type="number" @blur="blurs" v-model="tableDatas[scope.$index].money" />
                        </template>
                      </el-table-column>
                      <el-table-column label="备注" width="250">
                        <template slot-scope="scope">
                          <input type="text" v-model="tableDatas[scope.$index].content" />
                        </template>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <span @click="dels(scope.$index)" style="color:red;">删除</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>

                  <el-dialog title="选择付款人" :visible.sync="paydialogs" width="30%" center>
                    <div>
                      <el-checkbox :indeterminate="isIndeterminates" v-model="checkAlls" @change="handleCheckAllChanges">全选</el-checkbox>
                      <div style="margin: 25px 0;"></div>
                      <el-checkbox-group v-model="checkedCitiess" @change="handleCheckedCitiesChanges">
                        <el-checkbox v-for="(city,index) in citiess" :label="city" :key="index">{{city.nickname}}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="confirms">确 定</el-button>
                      <el-button @click="paydialogs = false">取 消</el-button>
                    </span>
                  </el-dialog>
                </div>

                <div class="asidebox_child" style="margin:10px 0;" v-show="this.typeis == 1">
                  <div style="color:#999999;">付款说明</div>
                  <div class="asideboxs">
                    <textarea cols="30" rows="2" v-model="instructions"></textarea>
                  </div>
                </div>

                <div class="asidebox_child">
                  <div style="color:#999999;">输入密码</div>
                  <div class="asideboxs">
                    <input type="password" v-model="payypwds" />
                  </div>
                </div>

                <div class="asidebox_child" style="margin-top:10px;padding-bottom:10px;">
                  <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
                  <div class="asideboxss">
                    <div class="btns" @click="querens">确认付款</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="发红包" name="fourthone">
              <givered v-if="redflag"></givered>
            </el-tab-pane>
            <el-tab-pane label="提现" name="withdrawal">
              <withdraw :fa-msg="data.z_money"></withdraw>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-show="i==2" style="height:100%;">
          <transaction v-if="chilidflag"></transaction>
        </div>
        <div v-show="i==3" style="height:100%;">
          <security></security>
        </div>
        <el-dialog title="设置工作台密码" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false" :show-close="false">
          <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="ruleForm">
            <el-form-item label="输入密码" prop="pwd">
              <el-input type="password" v-model="form.pwd" placeholder="  请输入六到十六位密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password">
              <el-input type="password" v-model="form.password" placeholder="  请再次输入"></el-input>
            </el-form-item>
          </el-form>
          <p style="color:#999999;">工作台密码，是在兼职呗平台进入支付系统时（个人账户）进行的一种安全保障措施，输入安全密码进入个人账户。</p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
          </span>
        </el-dialog>

        <el-dialog title="付款确认" :visible.sync="paymentshow" width="50%" center>
          <div>
            <div>
              本次共付款
              <span style="color:red;">
                ￥
                <span style="font-size:.16rem;">{{totalmoney}}</span>
              </span>
              元，共有{{tableData.length}}位收款人
            </div>

            <el-table max-height="150" :data="tableData" :border="false" style="width: 100%">
              <el-table-column prop="nickname" label="收款人" width="180"></el-table-column>
              <el-table-column label="金额" prop="money" width="180"></el-table-column>
              <el-table-column label="备注" width="250" prop="content"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span @click="del(scope.$index)" style="color:red;">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="paymentshow = false">取 消</el-button>
            <el-button type="primary" @click="paymentconfirm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="收款确认" :visible.sync="paymentshows" width="50%" center>
          <div>
            <div>
              本次共付款
              <span style="color:red;">
                ￥
                <span style="font-size:.16rem;">{{totalmoneys}}</span>
              </span>
              元，共有{{tableDatas.length}}位收款人
            </div>

            <el-table max-height="150" :data="tableDatas" :border="false" style="width: 100%">
              <el-table-column prop="nickname" label="收款人" width="180"></el-table-column>
              <el-table-column label="金额" prop="money" width="180"></el-table-column>
              <el-table-column label="备注" width="250" prop="content"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span @click="dels(scope.$index)" style="color:red;">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="paymentshows = false">取 消</el-button>
            <el-button type="primary" @click="paymentconfirms">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="请输入工作台密码" :visible.sync="flag" width="30%" center :close-on-click-modal="false" :show-close="false">
          <el-input type="password" v-model="form.name"></el-input>
          <p style="text-align:right;margin-top:5px;">
            <span style="color:#4C71DB;" @click="forgetpass">忘记密码？</span>
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import transaction from "@/components/pay/transaction-records.vue";
import security from "@/components/pay/security-center.vue";
import givered from "@/components/pay/give-red.vue";
import withdraw from "@/components/pay/with-draw.vue";
import {
  userlist,
  usergallery,
  syatempassword,
  payadd,
  payispay,
  projectlist,
  getuserlist,
  salaryadd,
  exitlogin,
  externalgetUserList,
  externaltoadd
} from "@/api/login/login";
import QRCode from "qrcode";
import ExportJsonExcel from "js-export-excel";
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      fileflag: true,
      chilidflag: false,
      redflag: false,
      loading: false,
      exloginflag: false,
      valueoption: "",
      file_url: "",
      file_urls: "",
      file: "",
      files: "",
      fileType: [".xlsx", ".xls"],
      fileTypes: [".xlsx", ".xls", ".doc", ".docx"],
      upload: {
        // 设置上传的请求头部
        headers: { token: localStorage.getItem("token") },
        // 上传地址
        // url: "http://localhost:8080/api/web/upload/uploadFiles",
        url: "https://jzb.jianzhibei.cn/web/upload/uploadFiles",
        // 是否更新已经存在的用户数据
        isUploading: false,
        files: {}
      },

      uploads: {
        // 设置上传的请求头部
        headers: { token: localStorage.getItem("token") },
        // 上传地址
        // url: "http://localhost:8080/api/api/uploadFiles/upload",
        url: "https://jzb.jianzhibei.cn/api/uploadFiles/upload",
        // 是否更新已经存在的用户数据
        isUploading: false,
        files: { myfile: this.files }
      },
      paymentshow: false,
      paymentshows: false,
      instructions: "",
      instructionss: "",
      payypwd: "",
      payypwds: "",
      tableData: [],
      tableDatas: [],
      checkAll: false,
      checkAlls: false,
      checkedCities: [],
      checkedCitiess: [],
      cities: [],
      citiess: [],
      isIndeterminate: true,
      isIndeterminates: true,
      paydialog: false,
      paydialogs: false,
      payeelist: [],
      payeeflag: false,
      projectid: "",
      totalmoney: "",
      totalmoneys: "",
      options: [],
      option: [],
      value: "",
      typei: 0,
      types: ["直接付款", "文件付款"],
      payflag: false,
      flags: false,
      active: false,
      forms: {
        money: ""
      },
      activeNames: "firstone",
      labelPosition: "right",
      form: {
        name: "",
        pwd: "",
        password: ""
      },
      data: {},
      flag: false,
      list: ["我的账户", "在线交易", "交易记录", "安全中心"],
      i: 0,
      centerDialogVisible: false,
      rule: {
        money: [
          { required: true, message: "请输入金额", trigger: "change" },
          {
            pattern: /^\d+(\.\d{0,2})?$/,
            message: "只能是数字",
            trigger: "blur"
          }
        ]
      },
      rules: {
        pwd: [
          { required: true, validator: validatePass, trigger: "change" },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, validator: validatePass2, trigger: "change" }
        ]
      },
      typeis: "",
      projectids: "",
      userInfo:{},
      moneyflag: false,
      getLists: [
        {
          id: "18301383154",
          province: "用户名",
          city: "12",
          citys: "测试"
        }
      ]
    };
  },
  mounted () { },
  created () {
    this.userInfo= JSON.parse(localStorage.getItem('userInfo'));

    this.getlist();
  },
  methods: {
    //文件格式下载
    formatdownload () {
      const dataList = this.getLists;
      let option = {}; //   option代表的就是excel文件
      let dataTable = []; //   dataTable代表excel文件中的数据内容
      if (dataList) {
        for (let i in dataList) {
          let obj = {
            手机号: dataList[i].id,
            收款人名称: dataList[i].province,
            金额: dataList[i].city,
            描述: dataList[i].citys
          };

          dataTable.push(obj); //   设置excel每列获取的数据源
        }
      }
      option.filename = "文件格式"; //excel文件名
      //excel文件数据
      option.datas = [
        {
          //   excel文件的数据源
          sheetData: dataTable,
          //   excel文件sheet的表名
          sheetName: "sheet",
          //   excel文件表头名
          sheetHeader: ["手机号", "收款人名称", "金额", "描述"],
          //   excel文件列名
          sheetFilter: ["手机号", "收款人名称", "金额", "描述"]
        }
      ];
      //   创建ExportJsonExcel实例对象
      let toExcel = new ExportJsonExcel(option);
      //   调用保存方法
      toExcel.saveExcel();
    },
    //跳转详情
    detail (name) {
      this.i = 1;
      this.activeNames = name;
    },
    //确认退出登录
    confirmexitlogin () {
      this.exloginflag = false;
      let data = {};
      exitlogin(data).then(res => {
        if (res.code == 200) {
          this.$message.success("退出成功");
          //清除token
          localStorage.removeItem("token");
          //跳转
          this.$router.push({ name: "login" });
        }
      });
    },
    //退出登录
    exitlogin () {
      this.exloginflag = true;
    },
    // 文件上传中处理
    handleFileProgress () {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess (response, file, fileList) {
      if (response.code == 500) {
        this.$message({
          type: "warning",
          message: "文件格式不对或文件数据为空，请下载文件格式示例,"
        });
        this.fileflag = false
        return;
      }
      if (response.code == 200 && response.data.length == 0) {
        this.$message({
          type: "warning",
          message: "该项目下人员与文件内人员不匹配"
        });
        this.fileflag = false
        return;
      }
      this.tableData = response.data;
      console.log(this.tableData, "111111");

      this.file_url = response.file;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
    },
    // 提交上传文件
    submitUpload () {
      if (this.projectid != "") {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择项目"
        });
      }
    },
    // 上传文件之前的钩子
    beforeUpload (file) {
      const formData = new FormData(); // 声明一个FormData对象
      formData.append("file", file);
      this.file = formData;
      const isXlsx =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isXlsx) {
        this.$message.error("上传文件只能是 xlsx 或 xls 格式");
      }
      return isXlsx;
    },

    // 文件上传中处理
    handleFileProgresss () {
      this.uploads.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccesss (response, file, fileList) {
      this.file_urls = response.file;
      this.uploads.isUploading = false;
      this.$refs.uploads.clearFiles();
    },
    // 提交上传文件
    submitUploads () {
      this.$refs.uploads.submit();
    },
    // 上传文件之前的钩子
    beforeUploads (file) {
      const formData = new FormData(); // 声明一个FormData对象
      formData.append("file", file);
      console.log(file.type);

      this.file = formData;
      const isXlsx =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword";
      if (!isXlsx) {
        this.$message.error("上传文件可以是 xlsx 或 xls 格式或doc,docx");
      }
      return isXlsx;
    },
    //确认收款
    paymentconfirms () {
      let datas = {};
      let lists = [];
      this.tableDatas.forEach(item => {
        datas = {
          user_app_id: item.user_app_id,
          money: item.money,
          content: item.content,
          project_id: item.project_id,
          job_id: item.job_id,
          user_name: item.nickname
        };
        lists.push(datas);
      });
      let data = {
        type: this.typeis + 1,
        project_id: this.projectids,
        money: this.totalmoneys,
        data: lists,
        pay_password: this.payypwds,
        file_url: this.file_urls,
        content: this.instructionss
      };
      externaltoadd(data).then(res => {
        if (res.code == 200) {
          this.paymentshows = false;
          this.tableDatas = [];
          this.payypwds = "";
          this.totalmoneys = 0;
          this.valueoption = "请选择";
          this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //确认付款
    paymentconfirm () {
      let datas = {};
      let lists = [];
      if (this.typei == 0) {
        this.tableData.forEach(item => {
          datas = {
            user_app_id: item.user_app_id,
            money: item.money,
            content: item.content,
            project_id: item.project_id,
            job_id: item.job_id,
            user_name: item.nickname
          };
          lists.push(datas);
        });
      } else {
        this.tableData.forEach(item => {
          datas = {
            money: item.money,
            content: item.content,
            mobile: item.mobile,
            user_name: item.nickname
          };
          lists.push(datas);
        });
      }

      let data = {
        type: this.typei + 1,
        project_id: this.projectid,
        money: this.totalmoney,
        data: lists,
        pay_password: this.payypwd,
        file_url: this.file_url,
        content: this.instructions
      };
      salaryadd(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.paymentshow = false;
          this.totalmoney = 0;
          this.tableData = [];
          this.payypwd = "";
          this.instructions = "";
          this.value = "请选择";
          this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //设置付款金额
    blur () {
      let str = 0;
      this.tableData.forEach(item => {
        str += Number(item.money);
      });
      this.totalmoney = str;
    },
    //设置收款金额
    blurs () {
      let str = 0;
      this.tableDatas.forEach(item => {
        str += Number(item.money);
      });
      this.totalmoneys = str;
    },
    //确认收款
    querens () {
      this.moneyflag = false;
      if (this.tableDatas.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择收款人"
        });
        return;
      }
      if (this.payypwds == "") {
        this.$message({
          type: "warning",
          message: "请输入密码"
        });
        return;
      }

      const reg = /^\d+(\.\d{0,2})?$/;
      this.moneyflag = this.tableDatas.every(item => {
        return reg.test(item.money) && item.money > 0;
      });

      if (this.moneyflag) {
        this.paymentshows = true;
      } else {
        this.$message({
          type: "warning",
          message: "金额不能为空或为负"
        });
      }
    },
    //确认付款
    queren () {
      this.moneyflag = false;
      if (this.tableData.length == 0 && this.typei == 1) {
        this.$message({
          type: "warning",
          message: "请先上传文件"
        });
        return;
      }
      if (this.tableData.length == 0 && this.typei == 0) {
        this.$message({
          type: "warning",
          message: "请选择收款人"
        });
        return;
      }
      if (this.payypwd == "") {
        this.$message({
          type: "warning",
          message: "请输入密码"
        });
        return;
      }
      const reg = /^\d+(\.\d{0,2})?$/;
      this.moneyflag = this.tableData.every(item => {
        return reg.test(item.money) && item.money > 0;
      });

      if (this.moneyflag) {
        this.paymentshow = true;
      } else {
        this.$message({
          type: "warning",
          message: "金额不能为空或为负"
        });
      }
    },
    //删除人员
    del (i) {
      this.tableData.splice(i, 1);
      let str = 0;
      this.tableData.forEach(item => {
        str += parseFloat(item.money);
      });
      this.totalmoney = str;
    },
    dels (i) {
      this.tableDatas.splice(i, 1);
      let str = 0;
      this.tableDatas.forEach(item => {
        str += parseFloat(item.money);
      });
      this.totalmoneys = str;
    },
    //对外付款确定选择的人员
    confirm () {
      this.paydialog = false;
      this.tableData = this.checkedCities;
      let str = 0;
      this.tableData.forEach(item => {
        str += parseFloat(item.money);
      });
      this.totalmoney = str;
    },
    //对外收款确定选择的人员
    confirms () {
      this.paydialogs = false;
      this.tableDatas = this.checkedCitiess;
    },
    //对外收款选择人员
    handleCheckAllChanges (val) {
      this.checkedCitiess = val ? this.citiess : [];
      this.isIndeterminates = false;
    },
    handleCheckedCitiesChanges (value) {
      let checkedCount = value.length;
      this.checkAlls = checkedCount === this.citiess.length;
      this.isIndeterminates =
        checkedCount > 0 && checkedCount < this.citiess.length;
    },
    //对外付款选择人员
    handleCheckAllChange (val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    //选择付款人
    payees () {
      if (this.projectids != "") {
        this.paydialogs = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先选择项目"
        });
      }
    },
    //选择收款人
    payee () {
      if (this.projectid != "") {
        this.paydialog = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先选择项目"
        });
      }
    },
    //选择项目
    selectproject (e) {
      this.checkAll = false;
      this.tableData = [];
      this.totalmoney = 0;
      this.checkedCities = [];
      this.projectid = e;
      let data = {
        project_id: this.projectid
      };
      getuserlist(data).then(res => {
        this.cities = res.data;
      });
    },
    //选择对外收款项目
    selectprojects (e) {
      this.checkAlls = false;
      this.tableDatas = [];
      this.totalmoneys = 0;
      this.checkedCitiess = [];
      this.projectids = e;
      let data = {
        project_id: this.projectids
      };
      externalgetUserList(data).then(res => {
        this.citiess = res.data;
      });
    },
    //选择付款方式
    selecttype (i) {
      this.typei = i;
      this.totalmoney = 0;
      this.tableData = [];
    },
    //选择收款方式
    selecttypes (i) {
      this.typeis = i;
      this.tableDatas = [];
    },
    over () {
      this.active = true;
    },
    leave () {
      this.active = false;
    },
    //获取项目列表
    getproject () {
      let datas = {
        status: 1
      };
      projectlist(datas).then(res => {
        let data = {};
        res.data.forEach(item => {
          data = {
            value: item.project_id,
            label: item.name
          };
          this.options.push(data);
          this.option.push(data);
        });
      });
    },
    handleClick (tab, event) {
      if (tab.index == 1) {
        this.options = [];
        this.getproject();
      }
      if (tab.index == 2) {
        this.option = [];
        this.getproject();
      }
      if (tab.index == 3) {
        this.redflag = true
      } else {
        this.redflag = false
      }
    },
    forgetpass () {
      this.$router.push({ path: "/director-pay-pwd" });
    },
    submit () {
      let data = {
        password: this.form.name
      };
      syatempassword(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "密码正确"
          });
          this.flag = false;
          this.getlist();
        } else {
          this.$message({
            type: "error",
            message: "密码错误"
          });
        }
        this.form.name = "";
      });
    },
    cancels () {
      this.$message({
        type: "warning",
        message: "请输入工作台密码"
      });
    },
    cancel () {
      this.$message({
        type: "warning",
        message: "必须设置工作台密码才可使用"
      });
    },
    //支付宝支付
    submitalipay (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    //微信支付
    submitwechat (formName) {
      if (this.forms.money <= 0) {
        this.$message({
          type: "warning",
          message: "金额不能小于0"
        });
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.payflag = true;
          let data = {
            money: this.forms.money,
            pay_type: "wechat"
          };
          payadd(data).then(res => {
            if (res.code == 200) {
              let id = res.data.charge_no;
              let timer = setInterval(() => {
                payispay(id).then(res => {
                  if (res.code == 200) {
                    this.payflag = false;
                    this.$message({
                      type: "success",
                      message: "支付成功"
                    });
                    clearInterval(timer);
                    this.i = 0;
                    this.forms.money = "";
                    this.getlist();
                  } else {
                    if (this.payflag == false) {
                      clearInterval(timer);
                    }
                  }
                });
              }, 2000);
              let ops = {
                errorCorrectionLevel: "H",
                type: "image/png",
                quality: 0.3,
                width: 165,
                height: 165,
                text: res.data.code_url,
                color: {
                  dark: "#333333",
                  light: "#fff"
                }
              };
              QRCode.toCanvas(this.$refs.canvas, res.data.code_url, ops);
            }
          });
        } else {
          return false;
        }
      });
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            password: this.form.pwd,
            newpassword: this.form.password
          };
          usergallery(data).then(res => {
            if (res.code == 200) {
              this.centerDialogVisible = false;
              this.$message({
                type: "success",
                message: "设置成功"
              });
              this.getlist();
            }
          });
        } else {
          return false;
        }
      });
    },
    getlist () {
      userlist().then(res => {
        if (res.code == 200) {
          this.data = res.data;
        }
        if (res.code == 400) {
          this.centerDialogVisible = true;
        }
        if (res.code == 402) {
          this.flag = true;
        }
      });
    },
    select (i) {
      this.i = i;
      if (this.i == 0) {
        this.getlist();
      }
      if (this.i == 2) {
        this.chilidflag = true;
      } else {
        this.chilidflag = false;
      }
    }
  },
  components: {
    transaction,
    security,
    givered,
    withdraw
  }
};
</script>

<style lang='scss' scoped>
.page {
  height: 100vh;
  .top {
    height: 80px;
    background-color: #191d25;
    .top_child {
      width: 80%;
      margin: auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .top_childa {
      height: 100%;
      display: flex;
      align-items: center;
      .top_childas {
        margin-left: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        color: white;
        height: 100%;
        background-color: #4a72dd;
      }
      .img1 {
        width: 80px;
        height: 40px;
      }
    }
    .top_childb {
      .exitlogin {
        padding: 10px 10px 10px;
        color: white;
        background-color: #4a72dd;
      }
      display: flex;
      align-items: center;
    }
  }
  .content {
    height: 93%;
    background-color: #eeeeee;
    .content_top {
      // width: 80%;
      width: 1200px;
      margin: auto;
      height: 40px;
      border-radius: 8px;
      background-color: white;
      margin-bottom: 20px;
      display: flex;
      .content_topchild {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0 20px;
      }
      .content_topchilds {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: white;
        background-color: #4c71da;
        padding: 0 20px;
      }
    }
    .content_bottom {
      .paymentsty {
        text-align: center;
      }
      .asidebox {
        padding-top: 40px;
        padding-left: 20px;
        .asidebox_child {
          display: flex;
          align-items: center;
          .asideboxs {
            display: flex;
            margin-left: 20px;
          }
          .asideboxss {
            display: flex;
            flex-direction: column;
            margin-left: 20px;
            .asideboxss_child {
              .asideboxss_childs {
                display: flex;
                height: 50px;
                background-color: #eeeeee;
                .stys {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                }
              }
              width: 845px;
              height: 264px;
              background: #ffffff;
              box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
              opacity: 1;
              border-radius: 4px;
            }
          }
          .btn {
            width: 120px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ccc;
            border: 1px solid #ccc;
            border-radius: 8px;
          }
          .btns {
            width: 120px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            background-color: #4d71d9;
            border-radius: 8px;
          }
        }
      }
      .contentbottonchilda {
        width: 150px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        color: white;
        background-color: #03cc02;
        img {
          width: 30px;
          height: 30px;
        }
      }
      .contentbottonchildb {
        width: 150px;
        height: 30px;
        display: flex;
        color: white;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        background-color: #1496dc;
        img {
          width: 30px;
          height: 30px;
        }
      }
      .contentbottonchild {
        width: 10%;
        height: 30px;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        img {
          width: 30px;
          height: 30px;
        }
      }
      // height: 65%;
      // width: 79%;
      width: 1200px;
      margin: auto;
      background-color: white;
      border-radius: 8px;
      padding: 15px 10px 0;
      .content_bottom_one {
        color: white;
        width: 100%;
        height: 150px;
        background: linear-gradient(to right, #3f92e3, #2bcff1);
        border-radius: 8px;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .tool {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tool_child {
          width: 14%;
          padding: 10px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #e6e4e7;
          border-radius: 7px;
        }
      }
      .content_bottom_child {
        width: 100%;
        height: 150px;
        margin: 20px 0;
        display: flex;
        color: white;
        justify-content: space-between;
        align-items: center;
        .content_bottom_a {
          height: 100%;
          width: 33%;
          background: linear-gradient(to right, #ff8278, #ffca4f);
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content_bottom_b {
          height: 100%;
          width: 33%;
          border-radius: 8px;
          background: linear-gradient(to right, #ffb009, #ffca2f);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content_bottom_c {
          height: 100%;
          width: 33%;
          border-radius: 8px;
          background: linear-gradient(to right, #9d4fff, #7c87ff);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
